<template>
     <div @click="onClick(item.line1)">
        <div class="card relative mb-6 rounded-xl">
            <div class="campaign-image rounded-xl" :style="{ 'background-image': `url('${item.imageUrl}')` }"></div>
            <div
                class="label absolute -bottom-3 right-6 h-7 w-40 text-center text-base text-white py-2px uppercase"
            >{{ item.line1 }}</div>
        </div>
     </div>
</template>

<script>
export default {
    name: 'UltimateServiceItem',
    props: {
        item: {
            type: Object
        }
    },
    methods: {
        onClick: function (cateName) {
            if (this.item.cat == null) return;
            this.tracking.event("category", "click_category", cateName, null);
            this.$router.push({
                name: "ultimate-campaigns",
                params: {
                    cat: this.item.cat,
                },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/style/base/image.scss";

.card {
    object-fit: contain;
    box-shadow: 0 0 10px 0 rgba(23, 55, 127, 0.31);
    .label {
        background-image: url("~@/assets/button/bg.svg");
        background-size: 100%;
    }

    img {
        margin: auto;
    }

    .campaign-image {
        @include boxRatio($ratio: 33.33%);
    }
}
</style>
